import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useAdministradorEscala } from "@/hooks/useAdministradorEscala";
import { EscalaIntegracaoHistorico } from "./EscalaIntegracaoHistorico";
import { EscalaIntegracaoTab } from "./EscalaIntegracaoTab";
import { EscalaSincronizacaoPanel } from "./EscalaSincronizacaoPanel";

type Secao = "conexao" | "historico";

// Área da integração externa: o botão de sincronizar no topo e, abaixo, a
// configuração (só o Administrador) e o histórico das execuções (Gerente+).
export function EscalaIntegracaoArea() {
  const { administrador } = useAdministradorEscala();
  const [secao, setSecao] = useState<Secao | null>(null);
  const [execucoesVistas, setExecucoesVistas] = useState(0);
  // O papel chega depois do primeiro render: sem escolha do usuário, o padrão acompanha ele.
  const atual: Secao = administrador ? (secao ?? "conexao") : "historico";

  return (
    <Box>
      <EscalaSincronizacaoPanel onConcluida={() => setExecucoesVistas((n) => n + 1)} />
      {administrador && (
        <Tabs value={atual} onChange={(_, v: Secao) => setSecao(v)} sx={{ mb: 3 }}>
          <Tab label="Conexão e mapa de lojas" value="conexao" />
          <Tab label="Histórico" value="historico" />
        </Tabs>
      )}
      {atual === "conexao" && <EscalaIntegracaoTab />}
      {atual === "historico" && <EscalaIntegracaoHistorico recarregarEm={execucoesVistas} />}
    </Box>
  );
}
